import './chunk-455cdeae.js';
import './helpers.js';
import './chunk-e92e3389.js';
import './chunk-17b33cd2.js';
import './chunk-7e17a637.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { S as Select } from './chunk-4e788733.js';
export { S as BSelect } from './chunk-4e788733.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Select);
  }
};
use(Plugin);

export default Plugin;
